<div class="drawer" [class.open]="drawerService.opened()">
  <div class="header">
    <ng-content select="[title]"></ng-content>
    <button type="button" class="btn-close" (click)="drawerService.close()" aria-label="Close"></button>
  </div>
  <div class="body">
    <ng-content select="[body]"></ng-content>
  </div>
  <div class="footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
<div class="overlay" [class.open]="drawerService.opened()" (click)="drawerService.close()"></div>
